<template>
  <mobile v-if="gl.isMobile" class="mt-4" />
  <desktop v-else />
</template>

<script>
// vue
import { onMounted } from 'vue';

// store
import { useGl } from '@store/ts/gl';
import { useDashBoard } from '@store/ts/dashBoard';

// services
import Api from '@services/api';

// i18n
import { useI18n } from 'vue-i18n';

// components
import Desktop from './desktop.vue';
import Mobile from './mobile.vue';

// naive-ui
import { useNotification } from 'naive-ui';

export default {
    name: 'block-bots',
    components: {
        Mobile,
        Desktop,
    },
    setup() {
        // store
        const gl = useGl();
        const dashBoard = useDashBoard();

        // ui
        const notification = useNotification();

        // i18n
        const { t } = useI18n();

        const getBotsStats = async () => {
            try {
                dashBoard.botsStatsInfo = ( await Api.dashBoard({
                    dashboard_block: 'bot_stats',
                }) ).data.bot_stats;
            } catch {
                notification.error({
                    content: t('errorMessage'),
                    duration: 2500,
                    keepAliveOnHover: true,
                });
            };            
        };

        onMounted(() => {
            getBotsStats();
        });
    
        return {
            gl,
        };
    },
};
</script>